
import { useState } from 'react';
import { Interview } from '@/types/interview';
import { toast } from 'sonner';

export function useInterviewDialogs() {
  const [selectedInterview, setSelectedInterview] = useState<Interview | null>(null);
  const [isViewDialogOpen, setIsViewDialogOpen] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  
  const handleViewInterview = (interview: Interview) => {
    setSelectedInterview(interview);
    setIsViewDialogOpen(true);
  };

  const handleEditInterview = (interview: Interview) => {
    setSelectedInterview(interview);
    setIsEditDialogOpen(true);
  };

  const handleCloseViewDialog = () => {
    setIsViewDialogOpen(false);
    setSelectedInterview(null);
  };

  const handleCloseEditDialog = () => {
    setIsEditDialogOpen(false);
    setSelectedInterview(null);
  };

  const handleSendToFeeder = async () => {
    // This function is not needed in the Feeder page as interviews are already in the feeder
    toast.info('Dette intervjuet er allerede i køen');
  };

  return {
    selectedInterview,
    isViewDialogOpen,
    isEditDialogOpen,
    handleViewInterview,
    handleEditInterview,
    handleCloseViewDialog,
    handleCloseEditDialog,
    handleSendToFeeder
  };
}
